import {Entity, EntityModel} from "./entity.model";
import {IconType} from '../components/icons';

export interface NamedEntity extends Entity {
  name: string;
  full_name: string;
}

export class NamedEntityModel<T extends NamedEntity> extends EntityModel<T> {
  readonly name: string
  readonly full_name: string

  constructor(source: T, icon?: IconType) {
    super(source, icon);
    this.name = source.name
    this.full_name = source.full_name
  }
}
